import api from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import router from '@/router'
import ability from '@/libs/acl/ability'

export default {
  namespaced: true,
  state: {
    user: null,
    token_jwt: null,
    app_name: null,
    usuarioLogado: null,
  },
  getters: {
    GET_ROUTE_ROLE(state) {
      // testes coment
      const isChatBooster = state.user.ability.find(b => b.action === 'chatbooster')
      const isVSLBooster = state.user.ability.find(b => b.action === 'vslbooster')
      const isAdmin = state.user.ability.find(b => b.action === 'manage')
      if (isAdmin) {
        return 'admin'
      }
      if (isChatBooster && isVSLBooster) {
        return 'booster'
      }
      if (isChatBooster) {
        return 'chatbooster'
      }
      if (isVSLBooster) {
        return 'vslbooster'
      }
      return 'booster'
    },
    GET_TITLE_MENU(state) {
      const isChatBooster = state.user.ability.find(b => b.action === 'chatbooster')
      const isVSLBooster = state.user.ability.find(b => b.action === 'vslbooster')
      const isAdmin = state.user.ability.find(b => b.action === 'manage')
      if (isAdmin) {
        state.app_name = 'Booster Admin'
        return 'Booster Admin'
      }
      if (isChatBooster && isVSLBooster) {
        state.app_name = 'Booster'
        return 'Booster'
      }
      if (isChatBooster) {
        state.app_name = 'ChatBooster'
        return 'ChatBooster'
      }
      if (isVSLBooster) {
        state.app_name = 'VSLBooster'
        return 'VSLBooster'
      }
      state.app_name = 'Booster'
      return 'Booster'
    },
    getUser(state) {
      return state.user
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
      state.usuarioLogado = true
    },
    setTokenJWT(state, payload) {
      state.token_jwt = payload
    },
    setUsuarioDeslogado(state, payload) {
      console.log('setUsuarioDeslogado', payload)
      state.usuarioLogado = payload
    },
  },
  actions: {
    async findUserByUUID({ commit }, { uuid }) {
      return new Promise((resolve, reject) => {
        api
          .get(`/find?uuid=${uuid}`)
          .then(response => {
            commit('setUser', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    loginUserClientAdminDKP({ commit }, { user_email, token_admin }) {
      return new Promise((resolve, reject) => {
        api.post('/auth/admin', { user_email, token_admin })
          .then(response => {
            const { userData } = response.data

            useJwt.setToken(response.data.accessToken)
            useJwt.setRefreshToken(response.data.refreshToken)
            localStorage.setItem('userData', JSON.stringify(userData))
            ability.update(userData.ability)

            router.replace(getHomeRouteForLoggedInUser(userData.user_role))
              .then(() => {
                resolve(userData)
              })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
